<script setup lang="ts">
import type { NavbarDropdownType } from '..';

const { dropdownType } = defineProps<{
  dropdownType: NavbarDropdownType | null;
}>();
defineSlots<{ default: () => void }>();
// Needs to be here, otherwise TS confuses built-in Transition component with
// this one and reports missing props in template.
defineOptions({ name: 'NavbarDropdownTabTransition' });

const tabOrder: Record<NavbarDropdownType, number> = {
  relax: 0,
  exercise: 1,
};
type DropdownTransition = 'slide-left' | 'slide-right' | 'none';
const name = ref<DropdownTransition>('none');
watch(
  () => dropdownType,
  (vNew, vOld) => {
    if (!vOld || !vNew) {
      name.value = 'none';
    } else {
      const indexOld = tabOrder[vOld];
      const indexNew = tabOrder[vNew];
      name.value = indexNew > indexOld ? 'slide-left' : 'slide-right';
    }
  },
);
</script>

<template>
  <div class="relative w-full">
    <Transition :name>
      <slot />
    </Transition>
  </div>
</template>

<style scoped>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-property: transform, opacity;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-left-leave-active,
.slide-right-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.slide-left-enter-from {
  transform: translateX(50%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(-50%);
  opacity: 0;
}

.slide-right-enter-from {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(50%);
  opacity: 0;
}
</style>
